export enum ToastType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  INFO = "INFO",
  LOADING = "LOADING",
  ACCESSIBILITY = "ACCESSIBILITY"
}

export interface ToastModel {
  id?: string
  type: ToastType
  message: string
  autoClose?: number | false
}
